import {Injectable} from '@angular/core';
import {EnvironmentConfigService} from '../../core/config/environment-config.service';
import {HttpClient, HttpHeaders} from '@angular/common/http';
import {AuthenticationService} from '../authentication/authentication.service';
import {BehaviorSubject, Observable} from 'rxjs';
import {Base64Helper} from '../../utils/base64-helper';

@Injectable({
  providedIn: 'root'
})
export class FavoritesService {

  constructor(private httpClient: HttpClient,
              private environmentConfig: EnvironmentConfigService,
              private authenticationService: AuthenticationService) {
  }

  headers = new HttpHeaders().set('content-type', 'application/json')


  // private userFavoritesRealEstateIdsSubjects = new BehaviorSubject<string[]>([]);
  // public userFavoritesRealEstateIds$: Observable<string[]> = this.userFavoritesRealEstateIdsSubjects.asObservable();

  private favoritesSubject = new BehaviorSubject<string[]>([]);
  public favoritesObservable: Observable<string[]> = this.favoritesSubject.asObservable();

  getFavorites() {
    this.authenticationService.getIdToken().then(idToken => {
      if (typeof idToken === 'string') {
        let httpHeaders = new HttpHeaders()
          .set('Content-Type', 'application/json')
          .set('Authorization', idToken);
        this.httpClient.get<string[]>(`${this.environmentConfig.apiUrl}/favorites`, {headers: httpHeaders}).subscribe({
            next: data => {
              this.favoritesSubject.next(data);
            },
            error: err => {
              console.log('exception');
              console.log(err);
            }
          }
        );
      }
    });
  }

  includeFavorite(realEstateId: string) {
    this.authenticationService.getIdToken().then(idToken => {
      if (typeof idToken === 'string') {
        let httpHeaders = new HttpHeaders()
          .set('content-type', 'application/json')
          .set('Authorization', idToken);

        this.httpClient.post<null>(`${this.environmentConfig.apiUrl}/favorites`,
          {"real_estate_id": realEstateId},
          {'headers': httpHeaders})
          .subscribe({
            next: data => {
            },
            error: (error) => {
              console.error('Failed to fetch favorites:', error);
            },
            complete: () => {
              this.getFavorites();
            }
          });
      }
    });
  }

  deleteFavorite(realEstateId: string) {
    this.authenticationService.getIdToken().then(idToken => {
      if (typeof idToken === 'string') {
        let httpHeaders = new HttpHeaders()
          .set('content-type', 'application/json')
          .set('Authorization', idToken);

        this.httpClient.delete<null>(`${this.environmentConfig.apiUrl}/favorites/${Base64Helper.encode(realEstateId)}`,
          {'headers': httpHeaders})
          .subscribe({
            next: data => {},
            error: (error) => {
              console.error(`Failed to delete favorite ${realEstateId}:`, error);
            },
            complete: () => {
              this.getFavorites();
            }
          });
      }
    });
  }
}
